module.exports = __webpack_public_path__ + "img/map.000ff09f.png";